import React, { Component } from "react";
import ReportOptions from "./ReportOptions";

import SettingsTable from "../Alerts/SettingsTable";

import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import AddAlert from "@material-ui/icons/AddAlert";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Dialog from "@material-ui/core/Dialog";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "99%"
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
});

class AutoReportOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbarOpen: false,
      snackbarMsg: "",
      snackbarColor: "info",
      snackbarIcon: AddAlert,
      editOpen: false,
      editData: {}
    };
  }

  validateForm = options => {
    let startHourMinute = options[0].StartHour.split(":");
    
    if (!options[0] || options[0].LocationID < 0) {
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "A location must be selected"
      );
      return false;
    } else if (options[0].report.length === 0) {
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "A report must be selected"
      );
      return false;
    } else if (options[0].termsAvailableAtSite === false){
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "A terminal must be selected"
      );
      return false;
    } else if (
      startHourMinute[1] != 0 &&
      startHourMinute[1] != 15 &&
      startHourMinute[1] != 30 &&
      startHourMinute[1] != 45
    ) {
      this.showNotification(
        ErrorOutlineIcon,
        "danger",
        "Please choose a time at the quarter of the hour (08:15AM or 08:30AM)"
      );
      return false;
    } else {
      return true;
    }
  }

  saveReportSettings = options => {
    if (this.validateForm(options) === true){
      this.props.saveReportSettings(options);
    } 
  };

  updateReportSettings = (ID, options) => {
    if (this.validateForm(options) === true){
      this.props.updateReportSettings(ID, options);
    } 
  };

  showNotification = (icon, color, msg) => {
    this.setState({
      snackbarOpen: true,
      snackbarMsg: msg,
      snackbarColor: color,
      snackbarIcon: icon
    });
  };

  handleEditSetting = rowData => {
    // Open edit form dialog box
    this.setState({ editOpen: true, editData: rowData });
  };
  handleEditClose = () => {
    this.setState({ editOpen: false });
  };

  render() {
    const { Locations, multiple, member, token } = this.props;

    return (
      <div>
        <Snackbar
          place="tc"
          color={this.state.snackbarColor}
          icon={this.state.snackbarIcon}
          message={this.state.snackbarMsg}
          open={this.state.snackbarOpen}
          closeNotification={() => this.setState({ snackbarOpen: false })}
        />
        <ReportOptions
          Locations={Locations}
          multiple={multiple}
          member={member}
          saveReportSettings={this.saveReportSettings}
          token={token}
          options={this.state}
          title={"Create Auto Report"}
          buttonTitle={"Save"}
          autoReport={true}
          edit={false}
        />
        <GridItem xs={12} sm={12} md={12}>
          <SettingsTable
            key={0}
            type={"report"}
            memberSettings={member.Settings}
            memberId={member.MemberId}
            handleEditSetting={this.handleEditSetting}
          />
          <Dialog
            fullWidth={true}
            maxWidth="md"
            open={this.state.editOpen}
            onClose={this.handleEditClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            // className={classes.dialogControl}
          >
            <ReportOptions
              Locations={Locations}
              multiple={false}
              member={member}
              saveReportSettings={this.saveReportSettings}
              updateReportSettings={this.updateReportSettings}
              token={token}
              options={this.state}
              title={"Create Auto Report"}
              buttonTitle={"Save"}
              autoReport={true}
              edit={true}
              editData={this.state.editData}
              handleEditClose={this.handleEditClose}
            />
          </Dialog>
        </GridItem>
      </div>
    );
  }
}

export default withStyles(styles)(AutoReportOptions);



// WEBPACK FOOTER //
// ./src/components/ReportOptions/AutoReportOptions.jsx